import checkSegmentationOption from './CheckSegmentationOption';

export default (function ($element, experimentResultPromise) {
    var optionsEls = $element.find('> gw-segmentation-option'); // child directives in html on init
    var optionsModels = []; // children directives models store

    function showDefaultOptionIfNothingMatchesVariant() {
        var anyOptionShown = optionsModels.some(function (option) {
            return !option.isHidden;
        });
        var defaultOption = optionsModels.find(function (option) {
            return option.isDefault;
        });

        if (!anyOptionShown && defaultOption) {
            defaultOption.show();
        }
    }

    return {
        registerSegmentOption: function registerSegmentOption(option) {
            experimentResultPromise.then(function (variantValue) {
                if (checkSegmentationOption(option.optionValues, variantValue)) {
                    option.show();
                }
            }).finally(function () {
                optionsModels.push(option);
                if (optionsModels.length === optionsEls.length) {
                    // all child elements have registered check if we need to show the default option
                    showDefaultOptionIfNothingMatchesVariant();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/segmentation/_SegmentationUtil.js
// module id = 73
// module chunks = 0